import React from 'react';
import CDTopNav from './CDTopNav';
import { Outlet } from 'react-router-dom';

const FinanceLayout = () => {
    return (
        <div>
            <CDTopNav />
            <Outlet />
        </div>
    );
};

export default FinanceLayout;
